var _defs, _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "location_svg__a",
    x1: 7.863,
    x2: 7.863,
    y2: 12.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b77af4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.621,
    stopColor: "#8c4fe4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997,
    stopColor: "#773adc"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.83,
    cy: 12.908,
    r: 2.228,
    fill: "#32bedd"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.83 16.491a3.584 3.584 0 113.583-3.583 3.587 3.587 0 01-3.583 3.583zm0-6.558a2.975 2.975 0 102.97 2.975 2.978 2.978 0 00-2.97-2.975z",
    fill: "#50e6ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83 18a5.093 5.093 0 115.092-5.092A5.1 5.1 0 017.83 18zm0-9.576a4.484 4.484 0 104.483 4.484A4.489 4.489 0 007.83 8.424z",
    fill: "#9cebff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.863 0a3.894 3.894 0 00-3.771 4.063c0 1.772 2.249 5.922 3.274 8.413a.535.535 0 00.992 0c1.023-2.507 3.277-6.7 3.277-8.412A3.941 3.941 0 007.863 0zm0 5.5A1.677 1.677 0 119.54 3.826 1.676 1.676 0 017.863 5.5z",
    fill: "url(#location_svg__a)"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOCAxOCI+PGRlZnM+PGxpbmVhckdyYWRpZW50IGlkPSJhIiB4MT0iNy44NjMiIHgyPSI3Ljg2MyIgeTI9IjEyLjgxIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHN0b3Agb2Zmc2V0PSIwIiBzdG9wLWNvbG9yPSIjYjc3YWY0Ii8+PHN0b3Agb2Zmc2V0PSIuNjIxIiBzdG9wLWNvbG9yPSIjOGM0ZmU0Ii8+PHN0b3Agb2Zmc2V0PSIuOTk3IiBzdG9wLWNvbG9yPSIjNzczYWRjIi8+PC9saW5lYXJHcmFkaWVudD48L2RlZnM+PGNpcmNsZSBjeD0iNy44MyIgY3k9IjEyLjkwOCIgcj0iMi4yMjgiIGZpbGw9IiMzMmJlZGQiLz48cGF0aCBkPSJNNy44MyAxNi40OTFhMy41ODQgMy41ODQgMCAxMTMuNTgzLTMuNTgzIDMuNTg3IDMuNTg3IDAgMDEtMy41ODMgMy41ODN6bTAtNi41NThhMi45NzUgMi45NzUgMCAxMDIuOTcgMi45NzUgMi45NzggMi45NzggMCAwMC0yLjk3LTIuOTc1eiIgZmlsbD0iIzUwZTZmZiIvPjxwYXRoIGQ9Ik03LjgzIDE4YTUuMDkzIDUuMDkzIDAgMTE1LjA5Mi01LjA5MkE1LjEgNS4xIDAgMDE3LjgzIDE4em0wLTkuNTc2YTQuNDg0IDQuNDg0IDAgMTA0LjQ4MyA0LjQ4NEE0LjQ4OSA0LjQ4OSAwIDAwNy44MyA4LjQyNHoiIGZpbGw9IiM5Y2ViZmYiLz48cGF0aCBkPSJNNy44NjMgMGEzLjg5NCAzLjg5NCAwIDAwLTMuNzcxIDQuMDYzYzAgMS43NzIgMi4yNDkgNS45MjIgMy4yNzQgOC40MTNhLjUzNS41MzUgMCAwMC45OTIgMGMxLjAyMy0yLjUwNyAzLjI3Ny02LjcgMy4yNzctOC40MTJBMy45NDEgMy45NDEgMCAwMDcuODYzIDB6bTAgNS41QTEuNjc3IDEuNjc3IDAgMTE5LjU0IDMuODI2IDEuNjc2IDEuNjc2IDAgMDE3Ljg2MyA1LjV6IiBmaWxsPSJ1cmwoI2EpIi8+PC9zdmc+";
export { SvgLocation as ReactComponent };